import { useState, useEffect } from 'react';
import CheckboxInput from './checkbox';
import ButtonPrimary from '../button/button-primary';
import { ButtonSize, ButtonType } from '../button/types';
import ButtonPseudo from '../button/button-pseudo';
import { CheckboxFilterTypes } from './types';

export default function CheckboxFilter({
  fields,
  onChange,
  name,
  values,
  withClearButton,
  type,
}: CheckboxFilterTypes) {
  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  useEffect(() => {
    if (values && values.value) {
      setSelectedValues(values.value);
    }
  }, [values]);

  return (
    <div>
      {fields?.map((item) => (
        <div
          key={`${name}-${item.value as string}`}
          className="checkbox-filter-wrapper"
        >
          <CheckboxInput
            name={`${name}-${item.value as string}`}
            type={type}
            title={item.title}
            checked={selectedValues.includes(item.value as string)}
            visualClassName="checkbox-filter-visual"
            onChange={(e) => {
              const { checked } = e.target;

              let nextSelectedValues: string[];

              if (type === 'checkbox') {
                nextSelectedValues = ([] as string[]).concat(selectedValues);

                if (checked) {
                  nextSelectedValues.push(item.value as string);
                } else {
                  nextSelectedValues = nextSelectedValues.filter(
                    (selected) => selected !== item.value,
                  );
                }

                setSelectedValues(nextSelectedValues);
              } else {
                nextSelectedValues = [item.value as string];
              }

              if (onChange) {
                onChange(nextSelectedValues);
              }
            }}
          />
          <br />
        </div>
      ))}
      {withClearButton && (
        <div className="checkbox-filter-submit-wrapper">
          <ButtonPrimary
            size={ButtonSize.SMALL}
            type={ButtonType.SUBMIT}
            text="Apply"
          />
          <ButtonPseudo
            size={ButtonSize.SMALL}
            text="Clear"
            className="clear-button"
            onClick={() => {
              setSelectedValues([]);

              if (onChange) {
                onChange([]);
              }
            }}
          />
        </div>
      )}
    </div>
  );
}
